import { render, staticRenderFns } from "./SchoolInfo.vue?vue&type=template&id=7139c8c2&scoped=true"
import script from "./SchoolInfo.vue?vue&type=script&lang=js"
export * from "./SchoolInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7139c8c2",
  null
  
)

export default component.exports